function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSkinnyArrow = function SvgSkinnyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.77 20.485a1 1 0 0 1-1 1H4.2a1 1 0 1 1 0-2H36.77a1 1 0 0 1 1 1Z",
    fill: props.color,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.308 7.279a1 1 0 0 1 1.413.028L38.386 20.5 25.721 33.693a1 1 0 1 1-1.442-1.386L35.614 20.5 24.279 8.693a1 1 0 0 1 .029-1.414Z",
    fill: props.color,
    stroke: props.color
  }));
};
export default SvgSkinnyArrow;